export const getFieldName = (fieldName: string, prefix?: string) => (prefix ? `${prefix}.${fieldName}` : fieldName);
